export function kpis(state) {
    return state.dashboard ? state.dashboard.kpis : null
}

export function charts(state) {
    return state.dashboard ? state.dashboard.charts : null
}



// WEBPACK FOOTER //
// ./src/modules/dashboard-sale-indicators/getters.js